const STORAGE_KEY = 'presence_csid'

// In-memory fallback for environments where sessionStorage is unavailable
// (private browsing quota errors, etc.). Guarantees one stable id per tab lifetime.
let memoryFallbackId: string | null = null

const getOrCreateClientSessionId = (): string => {
  try {
    const existing = sessionStorage.getItem(STORAGE_KEY)
    if (existing) return existing

    const id = crypto.randomUUID()
    sessionStorage.setItem(STORAGE_KEY, id)
    return id
  } catch {
    // sessionStorage unavailable — use or mint the in-memory id
    if (!memoryFallbackId) {
      memoryFallbackId = crypto.randomUUID()
    }
    return memoryFallbackId
  }
}

export default getOrCreateClientSessionId
